import React, { ReactElement, useRef } from 'react';
import "./Accordion.css"
interface IAccordionProps {
    children: ReactElement | ReactElement[]
    containerClass?: string
    singleOpen?: boolean
}
export default function Accordion({ children, containerClass, singleOpen }: IAccordionProps) {
    const accordionId = useRef("accordion_" + Math.random().toString(36).substr(2, 9)).current;;
    return (
        <div className={`accordion ${containerClass} d-flex flex-column gap-2 my-2`} id={accordionId}>
            {React.Children.map(children, (child) =>
                React.isValidElement(child)
                    ? React.cloneElement(child as ReactElement<any>, {
                        parentId: singleOpen ? accordionId : undefined
                    })
                    : child
            )}
        </div>
    );
}